import { atom } from "jotai";
import type {ScanResult} from "./scan-model/ScanResult.tsx";
import {AnalysisOptionsDep} from "../2-option-selection/AnalysisOptions.ts";

export const ScanAtom = atom<ScanResult | null>(null)
//If the analysis options change, reset the scan data
AnalysisOptionsDep((set) => set(ScanAtom, null))